module.exports = __webpack_public_path__ + "img/a.8b4b2828.jpg";